import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
// import axios from "axios";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Table,
  UncontrolledTooltip,
  Spinner,
  Pagination,
  PaginationItem,
  PaginationLink,
  FormGroup,
  Modal,
} from "reactstrap";

import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

// actions
import {
  resetRoles,
  resetError,
  getRoles,
  deleteRole,
} from "../../store/actions";

import { useDispatch, useSelector } from "react-redux";

//i18n
import { withTranslation } from "react-i18next";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

import BadgesEllipsisRole from "../../components/Common/BadgeEllipsisRole";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";

const Roles = ({ t }) => {
  const dispatch = useDispatch();
  const qtdDefault = 7;

  const {
    dataRole,
    dataRoleDelete,
    loadingRole,
    loadingRoleDelete,
    errorRole,
    successRole,
  } = useSelector((state) => state.Role);

  const [page, setPage] = useState(1);
  const [modal, setModal] = useState(false);
  const [roleId, setRoleId] = useState("");
  const [roleName, setRoleName] = useState("");
  const [nameFilter, setNameFilter] = useState("");
  const [descriptionFilter, setDescriptionFilter] = useState("");
  const [typeFilter, setTypeFilter] = useState("");

  const [notFound, setNotFound] = useState(false);

  const showToast = (type, message) => {
    toastr[type](message);
  };
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () => successRole && dispatch(resetRoles()) && handleFilter(),
  };

  const handleFilter = (name, description, type) => {
    setNameFilter(name);
    setDescriptionFilter(description);
    setTypeFilter(type);
    setPage(1);
    dispatch(getRoles(1, qtdDefault, name, description, type));
  };

  const handleDelete = () => {
    dispatch(deleteRole(roleId));
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const setRoleIdName = (role) => {
    setRoleId(role.id);
    setRoleName(role.name);
  };

  const handlePage = (value) => {
    setPage(value);
    dispatch(getRoles(value, qtdDefault, nameFilter, descriptionFilter, typeFilter));
  };

  const handlePreviousPage = () => {
    if (page > 1) {
      handlePage(page - 1);
    }
  };

  const handleNextPage = () => {
    if (dataRole && dataRole.paging) {
      if (page < dataRole.paging.length) {
        handlePage(page + 1);
      }
    }
  };

  useEffect(() => {
    if (dataRoleDelete && dataRoleDelete.message) {
      showToast("success", t(dataRoleDelete.message));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successRole]);

  useEffect(() => {
    if (errorRole && typeof errorRole === "object") {
      errorRole.map(
        //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
        (error) =>
          error.value !== "not found" && showToast("error", t(error.value))
      );
      dispatch(resetError());
    } else {
      if (errorRole) {
        showToast("error", t(errorRole));
        dispatch(resetError());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorRole]);

  useEffect(() => {
    if (dataRole !== null) {
      setNotFound(false);
    } else {
      setNotFound(true);
    }
  }, [dataRole]);

  const optionsType = useMemo(
    () => [
      { value: "", label: t("All") },
      { value: "admin", label: t("Admin") },
      { value: "manager", label: t("Manager") },
      { value: "agent", label: t("Agent") },
    ],
    [t]
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            mainPath="/dashboard"
            path="/roles"
            title={t("Dashboard")}
            breadcrumbItem={t("Roles")}
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <AvForm
                    onValidSubmit={(event, values) => {
                      handleFilter(values.name, values.description, values.type);
                    }}
                  >
                    <Row>
                      <Col xs="12" md="4" lg="3" xl="2" className="mb-3">
                        <FormGroup>
                          <AvField
                            label={t("Name")}
                            id="name"
                            name="name"
                            type="text"
                            className="form-control"
                            placeholder={t("Name") + "..."}
                            validate={{
                              pattern: {
                                value: "/^[A-Za-z0-9 áàâãéèêíïóôõöúç]*$/i", // only letters, numbers and space
                                errorMessage: t(
                                  "Name must be composed only with letter and numbers"
                                ),
                              },
                              minLength: {
                                value: 3,
                                errorMessage: t("Min 3 characters"),
                              },
                              maxLength: {
                                value: 60,
                                errorMessage: t("Max 60 characters"),
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col xs="12" md="4" lg="3" xl="2" className="mb-3">
                        <FormGroup>
                          <AvField
                            label={t("Description")}
                            id="description"
                            name="description"
                            type="text"
                            className="form-control"
                            placeholder={t("Description") + "..."}
                            validate={{
                              pattern: {
                                value: "/^[A-Za-z0-9 áàâãéèêíïóôõöúç]*$/i", // only letters, numbers and space
                                errorMessage: t(
                                  "Description must be composed only with letter and space"
                                ),
                              },
                              minLength: {
                                value: 3,
                                errorMessage: t("Min 3 characters"),
                              },
                              maxLength: {
                                value: 60,
                                errorMessage: t("Max 60 characters"),
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col xs="12" md="4" lg="3" xl="2" className="mb-3">
                        <FormGroup className="select2-container">
                          <AvField
                            name="type"
                            className="form-control"
                            type="select"
                            label={t("Type")}
                            options={optionsType}
                          >
                            {optionsType.map((option, key) => (
                              <option
                                key={key}
                                value={option.value}
                                disabled={option.isDisabled}
                              >
                                {option.label}
                              </option>
                            ))}
                          </AvField>
                        </FormGroup>
                      </Col>
                      <Col
                        xs="12"
                        md="4"
                        lg="auto"
                        className="mt-auto mb-3 filter-create-btn"
                      >
                        <Button
                          type="submit"
                          color="primary"
                          className="waves-effect waves-light w-100 mb-3 mr-3"
                        >
                          <i className="mdi mdi-feature-search-outline mr-1"></i>
                          {t("Search")}
                        </Button>
                      </Col>
                      <Col
                        xs="12"
                        md="12"
                        lg="auto"
                        className="mt-auto mb-3 ml-auto filter-create-btn"
                      >
                        <div className="text-sm-right mb-3" id="new-role">
                          <Link to={`/role`}>
                            <Button
                              type="button"
                              color="success"
                              className={"waves-effect waves-light w-100 mr-2 "}
                            >
                              <i className="mdi mdi-plus mr-1"></i>
                              {t("Add Role")}
                            </Button>
                          </Link>
                        </div>
                      </Col>
                    </Row>
                  </AvForm>

                  <div className="table-responsive scroll">
                    <PerfectScrollbar>
                      <Table className="table table-centered table-nowrap">
                        <thead className="thead-light">
                          <tr>
                            <th>{t("Name")}</th>
                            <th>{t("Description")}</th>
                            <th>{t("Type")}</th>
                            <th>{t("Permissions")}</th>
                            <th>{t("Action")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loadingRole ? (
                            <tr>
                              <td colSpan="20" align="center">
                                <Spinner
                                  size="sm"
                                  animation="border"
                                  style={{
                                    marginTop: "40px",
                                    height: "50px",
                                    width: "50px",
                                  }}
                                />
                              </td>
                            </tr>
                          ) : notFound ? (
                            <tr>
                              <td colSpan="20" align="center">
                                {t("Click search to show the records")}
                              </td>
                            </tr>
                          ) : dataRole &&
                            dataRole.roles &&
                            dataRole.roles.length > 0 ? (
                            dataRole.roles.map((role, key) => (
                              <tr key={key}>
                                <td>{role.name}</td>
                                <td>{role.description}</td>
                                <td>{t(role.type) ?? "-"}</td>
                                <td>
                                  {
                                    <BadgesEllipsisRole
                                      objItems={role.permissions}
                                      sizePx={400}
                                      toBadge={true}
                                    />
                                  }
                                </td>
                                <td>
                                  <Link
                                    to={`/role/${role.id}`}
                                    className="text-primary text-center"
                                    id="edit"
                                  >
                                    <i
                                      className="mdi mdi-pencil font-size-18 px-2"
                                      id="edittooltip"
                                    ></i>
                                    <UncontrolledTooltip
                                      placement="auto"
                                      target="edittooltip"
                                    >
                                      {t("Edit")}
                                    </UncontrolledTooltip>
                                  </Link>
                                  {/* TODO: add custom styles to css file */}
                                  {role.name !== "agent" &&
                                  role.name !== "manager" &&
                                  role.name !== "admin" &&
                                  role.name !== "admin_backoffice" &&
                                  role.name !== "super_admin" ? (
                                    <span style={{ cursor: "pointer" }}>
                                      <i
                                        className="mdi mdi-window-close text-danger font-size-18 px-2"
                                        id="deletetooltip"
                                        onClick={() => {
                                          toggleModal();
                                          setRoleIdName(role);
                                        }}
                                      ></i>
                                      <UncontrolledTooltip
                                        placement="auto"
                                        target="deletetooltip"
                                      >
                                        {t("Delete")}
                                      </UncontrolledTooltip>
                                    </span>
                                  ) : (
                                    <span className="isDisabled">
                                      {" "}
                                      <Link
                                        className="text-primary text-center"
                                        style={{
                                          pointerEvents: "none",
                                          cursor: "no-drop",
                                        }}
                                      >
                                        <i className="mdi mdi-window-close text-danger font-size-18 px-2"></i>
                                      </Link>
                                    </span>
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="20" align="center">
                                {t("No matching records found")}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                      <Modal isOpen={modal || loadingRoleDelete}>
                        <div className="modal-body font-size-18 text-center">
                          {t("Do you want to delete the role")}
                          <strong> {roleName}</strong>?
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            onClick={toggleModal}
                            className="btn btn-danger waves-effect"
                            data-dismiss="modal"
                            style={{ backgroundColor: "#f14646" }}
                          >
                            {t("No")}
                          </button>
                          {loadingRoleDelete ? (
                            <button
                              type="button"
                              className="btn btn-secondary waves-effect waves-light"
                              disabled
                            >
                              <Spinner size="sm" animation="border" />
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-secondary waves-effect waves-light"
                              onClick={() => {
                                toggleModal();
                                if (roleId) handleDelete();
                              }}
                            >
                              {t("Yes")}
                            </button>
                          )}
                        </div>
                      </Modal>
                    </PerfectScrollbar>
                  </div>

                  {dataRole && dataRole.paging && dataRole.paging.length > 1 ? (
                    <Pagination className="pagination pagination-rounded justify-content-end my-2">
                      <PaginationItem onClick={handlePreviousPage}>
                        <PaginationLink previous />
                      </PaginationItem>

                      {dataRole &&
                        dataRole.paging &&
                        dataRole.paging.map((value, index) => {
                          return (
                            <PaginationItem
                              key={index}
                              onClick={() => {
                                handlePage(value);
                              }}
                              active={page === value ? true : false}
                            >
                              <PaginationLink
                                key={index}
                                style={{ display: "inline" }}
                              >
                                {value}
                              </PaginationLink>
                            </PaginationItem>
                          );
                        })}
                      <PaginationItem onClick={handleNextPage}>
                        <PaginationLink next />
                      </PaginationItem>
                    </Pagination>
                  ) : (
                    ""
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Roles);
